import { NoConnectionIcon } from 'components/ui/icons';
import Placeholder from 'components/ui/placeholders/Placeholder';
import { translate } from 'utils/intlUtils';

import { BODY_TEXT } from 'styles/color';

const { t } = translate;

const NoConnection = () => (
  <Placeholder
    buttonText={t('refresh')}
    icon={<NoConnectionIcon color={BODY_TEXT} height={64} width={64} />}
    onClick={() => globalThis.location.reload()}
    subtitle={t('connection_error_placeholder_message')}
    title={t('no_connection')}
  />
);

export default NoConnection;
